import { render, staticRenderFns } from "./SelectVenuesModal.vue?vue&type=template&id=35d3d6c5&"
import script from "./SelectVenuesModal.vue?vue&type=script&lang=ts&"
export * from "./SelectVenuesModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectVenuesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports